import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './CollapsibleSEO.css';

const CollapsibleSEO = ({ title, firstParagraph, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="collapsible-seo">
      <h2>{title}</h2>
      <div className="seo-first-paragraph">
        {firstParagraph}
      </div>
      
      {isOpen && (
        <div className="seo-expandable-content">
          {children}
        </div>
      )}
      
      <button 
        className="seo-toggle-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <>
            <span>Weniger anzeigen</span>
            <ChevronUp size={20} />
          </>
        ) : (
          <>
            <span>Mehr lesen</span>
            <ChevronDown size={20} />
          </>
        )}
      </button>
    </div>
  );
};

export default CollapsibleSEO;
